export default "__VITE_ASSET__BO$WQ7j6__"